export default "__VITE_ASSET__DKjX1XQz__"